<template>
  <v-menu v-model="menuOpen" :close-on-content-click="false" transition="scale-transition" offset-y max-width="300">
    <template v-slot:activator="{on}">
      <v-text-field :label="label" class="text-body-2" readonly v-on="on" v-model="formatted" dense
                    append-icon="mdi-menu-down" @click:append="menuOpen=true" :disabled="disabled"
                    :rules="[valid]" outlined
                    :hint="contents" persistent-hint/>
    </template>

    <v-list dense>
      <v-list-item-group color="primary" mandatory v-model="selectedVessel">

          <v-menu offset-x nudge-left="10" max-height="300">
            <template v-slot:activator="{on:submenu}">
              <v-list-item value="Tank" v-on="submenu" @change="$emit('update:id', '')">
                <v-list-item-title>Tank</v-list-item-title>
                <v-list-item-action><v-icon>mdi-chevron-right</v-icon></v-list-item-action>
              </v-list-item>
            </template>
            <v-list dense>
              <v-list-item-group color="primary" v-model="selectedId">
                <template v-for="tank in tanks">
                  <v-list-item :key="tank.id" :value="tank.id" two-line @click="close('Tank', tank.id)">
                    <v-list-item-content>
                      <v-list-item-title>{{tank.name}}</v-list-item-title>
                      <v-list-item-subtitle class="text-caption" :class="{'green--text':highlight && highlight(tank)}" v-if="hint">
                        {{alcoholName(tank)}}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-list>
          </v-menu>

          <v-menu offset-x nudge-left="10" v-if="bulkContainers && bulkContainers.length" max-height="200">
            <template v-slot:activator="{on:submenu}">
              <v-list-item value="BulkContainer" v-on="submenu" @change="$emit('update:id', '')">
                <v-list-item-title>Bulk container</v-list-item-title>
                <v-list-item-action><v-icon>mdi-chevron-right</v-icon></v-list-item-action>
              </v-list-item>
            </template>
            <v-list dense>
              <v-list-item-group color="primary" v-model="selectedId">
                <template v-for="bulk in bulkContainers">
                  <v-list-item :key="bulk.id" :value="bulk.id" two-line @click="close('BulkContainer', bulk.id)">
                    <v-list-item-content>
                      <v-list-item-title>{{bulk.name}}</v-list-item-title>
                      <v-list-item-subtitle class="text-caption" :class="{'green--text':highlight && highlight(bulk)}" v-if="hint">
                        {{alcoholName(bulk)}}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-list>
          </v-menu>

      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'VesselSelect',
  props: {
		tanks: {type:Array,required:true},
		bulkContainers: {type:Array,required:false},
		label: {type:String,required:false},
		vessel: {type:String,required:false,default:''},
		id: {type:String,required:true},
    disabled: {type:Boolean,required:false,default:false},
		hint: {type:Boolean,required:false,default:true},
    highlight: {type:Function,required:false}
  },
  data() {
    return {
      menuOpen: false,
      selectedVessel: this.vessel,
      selectedId: this.id,
      valid: v => !!this.id || 'Required'
    }
  },
  computed: {
    formatted() {
      if (this.selectedVessel === 'Tank')
        return `Tank: ${this.tanks.find(t => t.id === this.selectedId)?.name || ''}`;
      return `${this.bulkContainers?.find(b => b.id === this.selectedId)?.name || ''}`;
    },
    contents() {
      if (!this.hint)
        return;
      const vessel = (this.selectedVessel === 'Tank'?this.tanks:this.bulkContainers).find(vessel => vessel.id === this.selectedId);
      if (vessel)
        return this.alcoholName(vessel);
    }
  },
  watch: {
    vessel() {
      this.selectedVessel = this.vessel;
    },
    id() {
      this.selectedId = this.id;
    }
  },
  methods: {
    alcoholName(vessel) {
      if (vessel.contents) {
        let amount = '(empty)';
        if (vessel.contents.alcoholType && vessel.contents.volume) {
          const spirits = vessel.contents.alcoholType === 'Spirit';
          amount = `${this.$number(vessel.contents.volume, 3)} ${spirits?'LAA':'litres'} ${vessel.contents.alcoholName}`;
        }
        return amount;
      }
    },
    close(vessel, id) {
      this.menuOpen = false;
      this.$emit('update:vessel', vessel);
      this.$emit('update:id', id);
      this.$emit('change');
    }
  }
}
</script>
